module.exports = __webpack_public_path__ + "static/media/search.b7504282.svg";